import { createAction, props } from '@ngrx/store';

import { Company } from '@models/company';

export const openCreateCompanyDialog = createAction('[App] Open Create Company Dialog');
export const openCreateCompanyDialogAfterClose = createAction(
  '[App] Open Create Company Dialog After Close',
  props<{ company: Company }>()
);
